import React from 'react';
import './infoMsgBox.css';

type Variant = 'info' | 'warning' | 'error' | 'success';

interface InfoMessageBoxProps {
  message: string | React.ReactNode;
  variant?: Variant | string;
}

const InfoMessageBox: React.FC<InfoMessageBoxProps> = ({
  message,
  variant = 'info',
}) => {
  return (
    <div className={`info-message-box ${variant}`}>
      {message}
    </div>
  );
};

export default InfoMessageBox;
